import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import {AiOutlineFilePdf} from "react-icons/ai";
// import { BsGithub } from "react-icons/bs";
// import { MdOndemandVideo } from "react-icons/md";
import PublicationCard from "./PublicationCards";
import NewsCard from "./NewsCards";
import TeachingCard from "./TeachingCards";
// import myImg from "../../Assets/avatar.svg";
// import Tilt from "react-parallax-tilt";
// import UnbiasedDesignPic from "../../Assets/UnbiasedDesign.png";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FaGraduationCap } from "react-icons/fa6";

function Home2() {
  const [showAllPubs, setShowAllPubs] = useState(false);
  const pubSectionRef = useRef(null);
  const didMountRef = useRef(false);

  // After toggling the publication list, jump back to the top of the section
  // (the toggle button lives at the bottom, so an expanded list would otherwise
  // leave the reader stranded far down the page). Skip the initial mount.
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    if (pubSectionRef.current) {
      pubSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showAllPubs]);

  return (
    <Container fluid className="home-about-section" id="about" >
      <Container>
        <Row>
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "1.6em" }}>
              <span className="black"> News </span>
            </h1>
            <NewsCard />
          </Col>
        </Row>
        <hr className="section-divider" />
        <Row ref={pubSectionRef} className="pub-section-anchor">
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "1.6em" }}>
              <span className="black">{showAllPubs ? " All Publications " : " Featured Publications "}</span>

            </h1>
            <PublicationCard
              showAll={showAllPubs}
              onToggle={() => setShowAllPubs((v) => !v)}
            />
          </Col>
        </Row>
        <hr className="section-divider" />
        <Row>
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "1.6em" }}>
              <span className="black"> Teaching </span>
            </h1>
            <TeachingCard />
          </Col>


        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            {/* <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="black">connect </span>with me
            </p> */}
            <ul className="home-about-social-links">


              <li className="social-icons">
                <a
                  href="https://scholar.google.com/citations?user=99HlmSkAAAAJ&hl=zh-CN&inst=1381320739207392350"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaGraduationCap />
                </a>
              </li>


              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/zixin-chen-669253204/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/CinderD"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/CinderdZixin"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>

            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
